export const ApplyToAll = 'Apply to All';
